import { parseTheme } from 'mol-ui';
import styled from 'styled-components';

export const Background = styled.div`
    align-items: center;
    background: #DDDDDD;
    display: flex;
    height: 100vh;
    justify-content: center;
    @media(max-width: 600px) {
        background: #EEEEEE;
    }
`;

export const TextError = styled.div`
    ${ parseTheme('color', 'dangerColor') }
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 10px;
    top: 40px;
`;

export const TextVersion = styled.div`
    ${ parseTheme('color', 'dangerColor') }
    font-size: 70px;
    top: 60px;
`;
